'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _enum = require('@vezeeta/enterprise-utils/lib/enum');

var _country = require('../actions/country');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var initialState = {
  Countries: [],
  AllCountries: [],
  CountriesList: [],
  nationalities: [],
  countriesCodes: new Map(),
  countriesMap: new Map(),
  countriesCodesMap: [],
  countriesDialCodes: new Map(),
  loaded: false,
  loading: false,
  countries: undefined,
  countriesLoadState: _enum.status.SHOULD_CALL_API
};

exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];

  var type = _ref.type,
      action = _objectWithoutProperties(_ref, ['type']);

  switch (type) {
    case _country.COUNTRIES.COUNTRIES.LOADING:
      return _extends({}, state, { countriesLoadState: _enum.status.FETCHING, countries: undefined });
    case _country.COUNTRIES.COUNTRIES.SUCCEEDED:
      {
        return _extends({}, state, { countriesLoadState: _enum.status.SUCCESS, countries: action.payload });
      }
    case _country.COUNTRIES.COUNTRIES.FAILED:
      return _extends({}, state, { countriesLoadState: _enum.status.FAIL });

    case _country.COUNTRY.LOAD:
      return Object.assign({}, state, { loaded: false }, { loading: true });
    case _country.COUNTRY.LOAD_DONE:
      {
        var countriesMap = new Map();
        var Countries = [];
        var nationalities = [];
        action.countries.forEach(function (country) {
          if (country.IsSupported) {
            Countries.push(country);
            countriesMap.set(country.CountryId, country);
          }
          var nationalityNameEnglish = void 0;
          var nationalityNameArabic = void 0;
          country.LanguageItemModels.map(function (model) {
            if (model.LanguageId === 1) {
              nationalityNameEnglish = model.Nationality;
            } else {
              nationalityNameArabic = model.Nationality;
            }
          });
          var countryNationality = {
            CountryId: country.CountryId,
            nationalityNameEnglish: nationalityNameEnglish,
            nationalityNameArabic: nationalityNameArabic
          };
          nationalities.push(countryNationality);
        });

        return _extends({}, state, {
          Countries: Countries,
          AllCountries: [].concat(action.countries),
          nationalities: nationalities,
          countriesMap: countriesMap,
          loaded: true,
          loading: false
        });
      }
    case _country.COUNTRY.LOAD_FAIL:
      return _extends({}, state, {
        loaded: false,
        loading: false
      });
    case _country.COUNTRY.LOAD_LIST:
      return _extends({}, state, {
        loaded: false,
        loading: true
      });
    case _country.COUNTRY.LOAD_LIST_DONE:
      {
        var countriesCodes = new Map();
        var countriesCodesMap = new Map();
        var countriesDialCodes = new Map();

        action.countries.forEach(function (country) {
          countriesCodes.set(country.IsoCode, country.DialCode);
          countriesCodesMap.set(country.IsoCode, country);
          countriesDialCodes.set(country.DialCode, country.IsoCode);
        });

        return _extends({}, state, {
          CountriesList: [].concat(action.countries),
          countriesCodes: countriesCodes,
          countriesCodesMap: countriesCodesMap,
          countriesDialCodes: countriesDialCodes,
          loaded: true,
          loading: false
        });
      }
    case _country.COUNTRY.LOAD_LIST_FAIL:
      return _extends({}, state, {
        loaded: false,
        loading: false
      });
    default:
      return state;
  }
};

module.exports = exports['default'];